import { render, staticRenderFns } from "./DetailReportMonth.vue?vue&type=template&id=196a78e0&scoped=true&"
import script from "./DetailReportMonth.vue?vue&type=script&lang=js&"
export * from "./DetailReportMonth.vue?vue&type=script&lang=js&"
import style0 from "./DetailReportMonth.vue?vue&type=style&index=0&id=196a78e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a78e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
